
<template>
    <v-data-table object :headers="tableHeaders" :items="tableItems" dense hide-default-footer :items-per-page="1000" style="height: 150px; overflow-y: auto">
        <template v-slot:headers="props">
            <tr style="height: 30px">
                <th style="height: 30px" v-for="header in props.headers" :class="checkAlignment(header.align)" :key="header.text">{{ header.text }}</th>
            </tr>
        </template>
        <template v-slot:items="props">
            <!-- <td style="height: 25px" v-for="k in tableHeaders" :key="k.text" :class="checkAlignment(k.align)">{{ props.item[k.value] }}</td> -->
            <td style="height: 25px" class="text-xs-left">{{props.item.name}}</td>
            <td style="height: 25px" class="text-xs-right">{{props.item.Fläche.toExponential()}}</td>            
            <td style="height: 25px" class="text-xs-right">{{props.item.Trägheitsmoment.toExponential()}}</td>
            <td style="height: 25px" class="text-xs-right">{{props.item.materialName}}</td>
        </template>                    
    </v-data-table>
</template>

<script>
/* eslint-disable */

export default {
    data(){
        return{
            initStatus: this.$store.initStatus,
            tableHeaders: [
                    { text: 'Name', align: 'left', value: 'name'},
                    { text: 'Fläche', align: 'right', sortable: false, value: 'Fläche'},
                    { text: 'Trägheitsmoment', align: 'right', sortable: false, value: 'Trägheitsmoment'},
                    { text: 'Material', align: 'right', sortable: false, value: 'materialName'}
                ],
        }
    },
    computed: {
        tableItems() { return this.$store.state.StatikSystem.Querschnittliste},
    },
    methods: {
        checkAlignment(payload){
            switch (payload){
                case 'right':
                    return "text-xs-right"
                case 'left' :
                    return "text-xs-left"
                default:
                    return "text-xs-center"
            }
        },
    }
}
</script>

<style scoped>
    select {
        padding-left: 5px; 
        padding-right: 5px;
        cursor: pointer;
        border-style: solid;
    }
    input {
        cursor: pointer;
        border-style: solid;
        border-width: thin;
    }
    .v-data-table--dense > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table--dense > .v-data-table__wrapper > table > thead > tr > td, .v-data-table--dense > .v-data-table__wrapper > table > tfoot > tr > td {
    height: 25px;
    }   
</style>